import React, { Component } from 'react';
import Raven from 'react-raven';
import { Redirect, BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { detect } from 'detect-browser';
import MainForm from '../../page/MainForm/MainForm';
import Success from '../../page/Success/Success';

/**
 * App Component Class
 */
export default class App extends Component {
  constructor() {
    super();
    this.state = {
      showBrowserNotification: false,
    };
  }
  /**
   * App componentDidMount
   */
  componentDidMount() {
    setTimeout(() => {
      const formHeight = document.getElementById('marketing-preference-form') !== null
        ? document.getElementById('marketing-preference-form').clientHeight
        : '1000';
      window.parent.postMessage('{"iframe_height":"' + formHeight + '"}', '*');
    }, 250);
    this.browserSupportMessage();
  }

  browserSupportMessage() {
    const browser = detect();

    if (browser) {
      if (browser.name === 'ie' && browser.version.match('9')) {
        this.setState({
          showBrowserNotification: true,
        });
      }
    }
  }
  /**
   * App Render
   * @return {*}
   */
  render() {
    return (
      <div id="app" className="app block-wrapper">
        {
          this.state.showBrowserNotification &&
          <div className="browser-message">
            <p>Unfortunately, this page doesn’t work with your version of Internet Explorer. <br />
              <a href="http://browser-update.org/update-browser.html#3.1.13:browser-update.org" className="link" target="parent" rel="nofollow">
              Please change or update your browser
              </a>
            </p>
          </div>
        }
        <Raven dsn="https://c42561537b2c486d8ca42a49ba06a800@sentry.io/1226484" />
        <Router>
          <Switch>
            <Route exact path="/" component={MainForm} />
            <Route exact path="/success" component={Success} />
            <Redirect push to="/" />
          </Switch>
        </Router>
      </div>
    );
  }
}
